import { Box } from '@mui/material';
import { commaSeparateNumber } from '@helpers';
import { hasPriceDiscount } from '@helpers/basket';
import { Typography } from '@elements';
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceDisplay = function PriceDisplay(_ref) {
  var basePrice = _ref.basePrice,
      finalPrice = _ref.finalPrice,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity,
      _ref$showQuantityPref = _ref.showQuantityPrefix,
      showQuantityPrefix = _ref$showQuantityPref === void 0 ? false : _ref$showQuantityPref,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      _ref$strikeColor = _ref.strikeColor,
      strikeColor = _ref$strikeColor === void 0 ? 'secondarySilver' : _ref$strikeColor,
      fontSize = _ref.fontSize,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? 500 : _ref$fontWeight,
      letterSpacing = _ref.letterSpacing,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'span' : _ref$component;
  var totalBase = basePrice * quantity;
  var totalFinal = finalPrice * quantity;
  var discounted = hasPriceDiscount(basePrice, finalPrice);
  return /*#__PURE__*/_jsxs(Box, {
    component: component,
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    flexWrap: "wrap",
    children: [showQuantityPrefix && quantity > 1 && /*#__PURE__*/_jsxs(Typography, {
      color: color,
      fontSize: fontSize,
      fontWeight: fontWeight,
      letterSpacing: letterSpacing,
      component: "span",
      children: [quantity, " x"]
    }), discounted && /*#__PURE__*/_jsxs(Typography, {
      color: strikeColor,
      fontSize: fontSize,
      fontWeight: fontWeight,
      letterSpacing: letterSpacing,
      component: "span",
      sx: {
        textDecoration: 'line-through'
      },
      children: [commaSeparateNumber(totalBase), " \u20BD"]
    }), /*#__PURE__*/_jsxs(Typography, {
      color: color,
      fontSize: fontSize,
      fontWeight: fontWeight,
      letterSpacing: letterSpacing,
      component: "span",
      children: [commaSeparateNumber(totalFinal), " \u20BD"]
    })]
  });
};

export { PriceDisplay };